module.exports = __webpack_public_path__ + "static/media/autokar2 (3).f9c31701.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar2 (3).jpg
// module id = 850
// module chunks = 0